import apiService from '../../../core/services/API';
import { environment } from '../../../environments/environment';
import { IAwardApplicationActionPayload } from '../../../core/interfaces/model';

export function doAction({ id, action, reason }: IAwardApplicationActionPayload) {
    return apiService.post({
        url: `${environment.api.awardApplications}/${id}/${action}`,
        data: reason !== undefined ? { rejectionReasons: reason } : undefined
    });
}
